import { Component, OnInit } from '@angular/core';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { EstructuraFisica } from '../../_models/estructura-fisica';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Location } from '@angular/common';
import { TerceroZonaService } from '../../_services/tercero-zona.service';
import { TerceroZona } from '../../_models/tercero-zona';
import { ZonaService } from '../../_services/zona.service';
import { Zona } from '../../_models/zona';
import { TerceroService } from '../../_services/tercero.service';
import { Tercero } from '../../_models/tercero';
import { log } from 'util';
import { TranslateService } from '@ngx-translate/core';

@Component( {
  selector: 'app-estructura-fisica-asignar-ejecutivo',
  templateUrl: 'estructura-fisica-asignar-ejecutivo.component.html'
} )

export class EstructuraFisicaAsignarEjecutivoComponent implements OnInit {

  carInformacionInicial = true;
  estFisica: EstructuraFisica = new EstructuraFisica();
  formulario: FormGroup;
  lisEjecutivos: SelectItem[] = [];
  lisZonas: SelectItem[] = [];
  lisZonasSecundarias: SelectItem[] = [];
  submitted = false;
  guardando = false;
  columnas: any[] = [];
  carTabla = false;
  lisEjecutivosZonas: TerceroZona[] = [];
  idEstructuraFisica: string;
  mostrarDialogo = false;
  indDesvincular = false;
  ejeSeleccionado: TerceroZona;
  forZonas: FormGroup;
  guaZonas = false;
  subZonas = false;
  carInformacionDialogo = false;
  lisTodasZonas: Zona[] = [];
  lisTerceros: Tercero[] = [];
  validandoIndicador:boolean = false;


  constructor( private estFisicaServicio: EstructuraFisicaService,
               private navServicio: NavService,
               private location: Location,
               private conServicio: ConfirmationService,
               private terZonaServicio: TerceroZonaService,
               private zonServicio: ZonaService,
               private terServicio: TerceroService,
               private route: ActivatedRoute, private fb: FormBuilder,
               private TranslateService:TranslateService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'ejecutivo', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_EJECUTIVO' ), sort: true },
      { field: 'zona', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_ZONA' ), sort: true },
      { field: 'secundarias', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_ZONARESPONSABLE' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idTercero: [ null, [ Validators.required ] ],
      indicadorPrincipal: [ true ],
      indicadorHabilitado: [ true ],
      idZona: [ null, [ Validators.required ] ]
    } );

    this.inicializarFormularioZonas();

    this.route.params.subscribe( ( params: Params ) => {
      this.idEstructuraFisica = params[ 'id' ];
      forkJoin(
        this.estFisicaServicio.getById( params[ 'id' ] ),
        this.terZonaServicio.obtenerPorEstructuraFisica( params[ 'id' ] ),
        this.terServicio.listadoPorEstructuraFisica( params[ 'id' ] ),
        this.zonServicio.getAllByEstructuraFisica( params[ 'id' ] )
      ).subscribe( ( [ estFisica, lisEjecutivosZonas, ejecutivos, todZonas ] ) => {
        this.estFisica = estFisica;
        this.lisTodasZonas = todZonas;
        this.lisEjecutivosZonas = this.obtenerZonasEjecutivos( lisEjecutivosZonas );
        this.lisTerceros = ejecutivos;
        this.cargarEjecutivos();
        this.cargarZonas();
        if ( this.lisEjecutivos.length === 0 ) {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.MSG_NOEXISTEEJECUTIVOS' )
          } );
        }

        if ( this.lisZonas.length === 0 ) {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.MSG_NOEXISTEZONAS' )
          } );
        }

        this.carInformacionInicial = false;
      } );
    } );
  }

  inicializarFormularioZonas() {
    this.forZonas = this.fb.group( {
      indicadorTodasZonas: [ null ],
      indicadorZonaPrincipal: [ null ],
      idZonas: [ [] ]
    });
  }
  cargarZonas() {
    this.lisZonas = [];
    this.lisTodasZonas.map( ( s: Zona ) => {
      const a = this.lisEjecutivosZonas.find( x => x.idZona === s.idZona || !!x.secundarias.find( y => y.idZona === s.idZona ) );
      if ( !a ) {
        this.lisZonas.push( { label: s.nombre, value: s.idZona } );
      }
    } );
  }

  cargarEjecutivos() {
    this.lisEjecutivos = [];
    this.lisTerceros.map( ( s: Tercero ) => {
      const a = this.lisEjecutivosZonas.find( x => x.idTercero === s.idTercero && (x.idZona !== '' && x.idZona !== null && x.idZona !== undefined) );
      if ( !a ) {
        this.lisEjecutivos.push( { label: s.nombreCompleto, value: s.idTercero } );
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.validarDisponibilidadZona$(this.formulario.value.idZona).subscribe((response) => {
        if ( response.indicadorDescargado !== null && response.indicadorDescargado === true ){
          this.navServicio.setMesage( 0,
            {
              severity: 'info',
              summary: this.navServicio.buscarMensaje( 'LBL_ADVERTENCIA' ),
              detail: this.navServicio.buscarMensaje( 'ZONES.MSG_ERROREDITARZONA')
            } );
          this.submitted = false;
        } else{
          this.conServicio.confirm( {
            message: this.navServicio.buscarMensaje( 'MSG_SEGUROGUARDAR' ),
            header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
            icon: 'fa fa-question-circle',
            accept: () => {
              this.guardando = true;
              const data = this.formulario.value;
              this.terZonaServicio.crear( data ).subscribe( creDatos => {
                this.terZonaServicio.obtenerPorEstructuraFisica( this.idEstructuraFisica ).subscribe( lisEjecutivosZonas => {
                  this.lisEjecutivosZonas = this.obtenerZonasEjecutivos( lisEjecutivosZonas );
                  this.cargarEjecutivos();
                  this.cargarZonas();
                  this.formulario.reset();
                  this.f.indicadorHabilitado.setValue( true );
                  this.f.indicadorPrincipal.setValue( true );
                  this.submitted = false;
                  this.navServicio.setMesage( 1 );
                  this.guardando = false;
                } );
              } );
            },
            reject: () => {
            }
          } );
        }
      });
    }
  }

  get f() {
    return this.formulario.controls;
  }

  get fSecundarias() {
    return this.forZonas.controls;
  }

  agregarZona( ejecutivo: TerceroZona ) {
    this.validandoIndicador = true;
    let idZona = this.getIdZonaValidar(ejecutivo);
    this.validarDisponibilidadZona$(idZona).subscribe((response) => {
      if ( response.indicadorDescargado !== null && response.indicadorDescargado === true ){
        this.navServicio.setMesage( 0,
          {
            severity: 'info',
            summary: this.navServicio.buscarMensaje( 'LBL_ADVERTENCIA' ),
            detail: this.navServicio.buscarMensaje( 'ZONES.MSG_ERROREDITARZONA')
          } );
        this.validandoIndicador = false;
      } else{
        this.validandoIndicador = false;
        this.carInformacionDialogo = true;
        this.mostrarDialogo = true;
        this.subZonas = false;
        this.fSecundarias.idZonas.clearValidators();
        this.fSecundarias.idZonas.setValidators( [ Validators.required ] );
        this.forZonas.reset();
        this.inicializarFormularioZonas();
        this.ejeSeleccionado = ejecutivo;
        this.lisZonasSecundarias = [];
        this.lisTodasZonas.map( ( s: any ) => {
          const a = this.lisEjecutivosZonas.find( x => x.idTercero === ejecutivo.idTercero && (x.idZona === s.idZona || x.secundarias.find( y => y.idZona === s.idZona ) !== undefined) );
          if ( !a ) {
            this.lisZonasSecundarias.push( { label: s.nombre, value: s.idZona } );
          }
        } );
        this.indDesvincular = false;
        this.carInformacionDialogo = false;
      }
    });
  }

  desvincularZona( ejecutivo: any ) {
    this.validandoIndicador = true;
    let idZona = this.getIdZonaValidar(ejecutivo);
    this.validarDisponibilidadZona$(idZona).subscribe((response) => {
      if ( response.indicadorDescargado !== null && response.indicadorDescargado === true ){
        this.navServicio.setMesage( 0,
          {
            severity: 'info',
            summary: this.navServicio.buscarMensaje( 'LBL_ADVERTENCIA' ),
            detail: this.navServicio.buscarMensaje( 'ZONES.MSG_ERROREDITARZONA')
          } );
        this.validandoIndicador = false;
      } else{
        this.validandoIndicador = false;
        this.carInformacionDialogo = true;
        this.mostrarDialogo = true;
        this.subZonas = false;
        this.fSecundarias.idZonas.clearValidators();
        this.fSecundarias.idZonas.setValidators( [] );
        this.forZonas.reset();
        this.inicializarFormularioZonas();
        this.ejeSeleccionado = ejecutivo;
        this.lisZonasSecundarias = [];
        this.ejeSeleccionado.secundarias.map( ( s: TerceroZona ) => {
          this.lisZonasSecundarias.push( { label: s.zona, value: s.idTerceroZona } );
        } );
        this.indDesvincular = true;
        this.carInformacionDialogo = false;
      }
    });

  }

  regresar() {
    this.location.back();
  }

  regZonas( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.mostrarDialogo = false;
        },
        reject: () => {
        }
      } );
    } else {
      this.mostrarDialogo = false;
    }
  }

  asignarEjecutivos() {
    this.subZonas = true;
    if ( this.forZonas.valid ) {
      this.validarDisponibilidadZonas$(this.forZonas.value.idZonas).subscribe((lstZonasDescargadas:any[]) => {
        console.log(lstZonasDescargadas);
        this.conServicio.confirm( {
          message: this.navServicio.buscarMensaje( 'MSG_SEGUROGUARDAR' ),
          header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          accept: () => {
            this.guaZonas = true;
            const data = this.forZonas.value;
            const datBulk = [];
            if ( this.indDesvincular ) {
              if ( data.indicadorTodasZonas ) {
                this.ejeSeleccionado.secundarias.map( ( s: TerceroZona ) => {
                  // s.idZona = null;
                  s.indicadorHabilitado = false;
                  datBulk.push( s );
                } );
                if ( this.ejeSeleccionado.idZona !== '' && this.ejeSeleccionado.idZona !== null && this.ejeSeleccionado.idZona !== undefined ) {
                  const eje = this.ejeSeleccionado;
                  eje.indicadorHabilitado = false;
                  // eje.idZona = null;
                  datBulk.push( eje );
                }
              } else {
                if ( data.indicadorZonaPrincipal && (this.ejeSeleccionado.idZona !== '' && this.ejeSeleccionado.idZona !== null && this.ejeSeleccionado.idZona !== undefined) ) {
                  const eje = this.ejeSeleccionado;
                  eje.indicadorHabilitado = false;
                  // eje.idZona = null;
                  datBulk.push( eje );
                }

                if ( data.idZonas ) {
                  data.idZonas.map( s => {
                    this.ejeSeleccionado.secundarias.map( ( zon: TerceroZona ) => {
                      if ( zon.idTerceroZona === s ) {
                        zon.indicadorHabilitado = false;
                        // zon.idZona = null;
                        datBulk.push( zon );
                      }
                    } )
                  } );
                }
              }
            } else {
              if ( data.idZonas ) {
                data.idZonas.map( s => {
                  let existeZona = lstZonasDescargadas.find(x => x.idZona == s);
                  if ( existeZona == undefined || (existeZona && !existeZona.indicadorDescargado)){
                    const nueRegistro = {
                      idZona: s,
                      idTercero: this.ejeSeleccionado.idTercero,
                      indicadorHabilitado: true,
                      indicadorPrincipal: false
                    };
                    datBulk.push( nueRegistro );
                    this.lisEjecutivosZonas.map( ( zon: TerceroZona ) => {
                      if ( zon.idTercero !== this.ejeSeleccionado.idTercero ) {
                        if ( zon.idZona === s ) {
                          zon.indicadorHabilitado = false;
                          // zon.idZona = null;
                          datBulk.push( zon );
                        } else {
                          zon.secundarias.map( ( secundaria: TerceroZona ) => {
                            if ( secundaria.idZona === s ) {
                              secundaria.indicadorHabilitado = false;
                              // secundaria.idZona = null;
                              datBulk.push( secundaria );
                            }
                          } );
                        }
                      }
                    } );
                  }

                } );
              }
            }

            let mensaje = '';

            if ( lstZonasDescargadas.length > 0 ){
              let zonasOcupadas = '';
              lstZonasDescargadas.map((x, index) => {
                zonasOcupadas += ( (lstZonasDescargadas.length - 1) == index ) ? x.nombre : x.nombre+', ';
                if ( (lstZonasDescargadas.length - 1) == index ) {
                  this.TranslateService.get('ESTRUCTURAFISICA.MSG_GUARDADOZONASBULK', {value: zonasOcupadas}).subscribe(res => {
                    mensaje = res;
                  });
                }
              });
            }

            if ( datBulk.length > 0 ) {
              this.terZonaServicio.bulk( datBulk ).subscribe( res => {
                this.terZonaServicio.obtenerPorEstructuraFisica( this.idEstructuraFisica ).subscribe( lisEjecutivosZonas => {
                  this.lisEjecutivosZonas = this.obtenerZonasEjecutivos( lisEjecutivosZonas );
                  this.cargarEjecutivos();
                  this.cargarZonas();
                  if ( lstZonasDescargadas.length > 0 ) {
                    this.navServicio.setMesage( 0,
                      {
                        severity: 'success',
                        summary: 'Éxito',
                        detail: mensaje
                      } );
                  }else{
                    this.navServicio.setMesage( 1 );
                  }
                  this.guaZonas = false;
                  this.mostrarDialogo = false;
                } );
              } );
            } else {
              if ( lstZonasDescargadas.length > 0  ) {
                this.navServicio.setMesage( 0,
                  {
                    severity: 'info',
                    summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                    detail: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.MSG_BULKZONASDESCARGADAS' )
                  } );

              }else{
                this.navServicio.setMesage( 1 );
              }
              //this.navServicio.setMesage( 1 );
              this.guaZonas = false;
              this.mostrarDialogo = false;
            }

          },
          reject: () => {
          }
        } );
      });

    }
  }

  obtenerZonasEjecutivos( lisTercerosZonas: TerceroZona[] ) {
    const datos = [];
    lisTercerosZonas.map( ( s: TerceroZona ) => {
      if ( s.indicadorHabilitado ) {
        const terZona = datos.findIndex( x => x.idTercero === s.idTercero );
        if ( terZona >= 0 ) {
          if ( s.indicadorPrincipal ) {
            s.secundarias = datos[ terZona ].secundarias;
            s.secundariasTexto = datos[ terZona ].secundariasTexto;
            datos[ terZona ] = s;
          } else {
            datos[ terZona ].secundariasTexto += datos[ terZona ].secundariasTexto ? ('-' + s.zona) : s.zona;
            datos[ terZona ].secundarias.push( s );
          }
        } else {
          if ( s.indicadorPrincipal ) {
            s.secundarias = [];
            s.secundariasTexto = '';
            datos.push( s );
          } else {
            const nueTerZona: TerceroZona = {
              id: null,
              idTerceroZona: null,
              idTercero: s.idTercero,
              secundarias: [],
              secundariasTexto: s.zona,
              idZona: null,
              zona: null,
              tercero: s.tercero,
              indicadorPrincipal: true,
              indicadorHabilitado: true,
              auditoriaUsuario: null,
              auditoriaFecha: null
            };
            nueTerZona.secundarias.push( s );
            datos.push( nueTerZona );
          }
        }
      }
    } );
    return datos;
  }

  validarDisponibilidadZona$(idZona:string){
    return this.zonServicio.get(idZona);
    /*let b = false;
    let a = of(b);
    return a;*/
  }

  validarDisponibilidadZonas$(idZonas:string[]){
    return this.zonServicio.getIndicadorEdicionZonas(idZonas);
    /*let b = [{nombre:'Zona 03', idZona:13, indicadorEdicion:false},{nombre:'Zona 04', idZona:14, indicadorEdicion:true}];
    let ocup = b.filter(x => x.indicadorEdicion);
    let a = of(ocup);
    return a;*/
  }

  getIdZonaValidar(tercero:TerceroZona){
    let idZona = null;
    if ( tercero.idZona && tercero.idZona != null ) {
      idZona = tercero.idZona;
    }else if(tercero.secundarias.length > 0){
      idZona = tercero.secundarias[0].idZona;
    }

    return idZona;
  }

  armarMensajeGuardar(lstZonasOcupadas:any[]){
    let msg = '';
    if ( lstZonasOcupadas.length > 0 ){
      let zonasOcupadas = '';
      lstZonasOcupadas.map((x, index) => {
        zonasOcupadas += ( (lstZonasOcupadas.length - 1) == index ) ? x.nombre : x.nombre+', ';
        if ( (lstZonasOcupadas.length - 1) == index ) {
          this.TranslateService.get('ESTRUCTURAFISICA.MSG_GUARDADOZONASBULK', {zonasOcupadas}).subscribe(res => {
            console.log(res);
            msg = res;
            return msg;
          });
          //this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.MSG_GUARDADOZONASBULK' );
          //msg = 'Las zonas se asignaron correctamente excepto: la(s) zona(s): '+zonasOcupadas+' porque se encuentra(n) siendo gestionada(s) por un ejecutivo en el móvil';
        }
      });
    }
  }
}
